import { useCallback, useEffect, useMemo, useState } from "react";
import { getLandedCostVendorHistory } from "../../API/landedCostVendorHistoryApi";

const extractHistory = (rawHistory) => {
  if (Array.isArray(rawHistory)) {
    return rawHistory;
  }

  if (rawHistory && typeof rawHistory === "object") {
    if (Array.isArray(rawHistory.elements)) {
      return rawHistory.elements;
    }
    if (Array.isArray(rawHistory.queryResults)) {
      return rawHistory.queryResults;
    }
    if (Array.isArray(rawHistory.data)) {
      return rawHistory.data;
    }
    if (Array.isArray(rawHistory.rows)) {
      return rawHistory.rows;
    }
    if (Array.isArray(rawHistory.content)) {
      return rawHistory.content;
    }
  }

  return [];
};

export const useLandedCostVendorHistory = () => {
  const [rawHistory, setRawHistory] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchUploadHistory = useCallback(async () => {
    setLoading(true);
    try {
      const history = await getLandedCostVendorHistory();
      setRawHistory(history || []);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchUploadHistory();
  }, [fetchUploadHistory]);

  const uploadHistory = useMemo(() => extractHistory(rawHistory), [rawHistory]);

  return { uploadHistory, fetchUploadHistory, loading };
};
